import { useEffect } from 'react';
import useKupStore from '~kup/store';

export default function useSyncBasket() {
  const { syncBasket } = useKupStore((state) => ({ syncBasket: state.syncBasket }));
  useEffect(() => {
    syncBasket().catch(console.error);
  }, [syncBasket]);
}
